import { getNameFromLanguage } from './language';

export const getIconFromReference = reference =>
  getNameFromLanguage(reference)?.icon ?? 'Chickfila';
